import { Link } from 'react-router-dom';

interface Crumb {
  name: string;
  path?: string;
}

function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-sm text-foreground-600">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1.5">
              {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
              {item.path && !isLast ? (
                <Link to={item.path} className="transition-colors hover:text-primary-600">
                  {item.name}
                </Link>
              ) : (
                <span className={isLast ? 'font-bold text-foreground-950' : ''} aria-current={isLast ? 'page' : undefined}>
                  {item.name}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumb;